import { Component } from "@angular/core";
import { StepsMenuItem } from "../../../shared/menu/steps-menu/steps-menu-item";

@Component({
  selector: "toolbox-steps-menu",
  templateUrl: "./steps-menu.component.html",
})
export class StepsMenuComponent {
  activeIndex = 0;
  menuItems = [
    new StepsMenuItem({
      label: "MEMBER",
    }),
    new StepsMenuItem({
      label: "AID",
    }),
    new StepsMenuItem({
      label: "PROVIDER",
    }),
    new StepsMenuItem({
      label: "MEASURE",
    }),
    new StepsMenuItem({
      label: "DOCUMENTS",
    }),
    new StepsMenuItem({
      label: "FINAL REVIEW",
    }),
  ];

  submit() {
    this.activeIndex++;
  }
}
